export { default } from './useReportRoute';
